(function () {
  function init(root) {
    if (!root || root.dataset.mtBtgReady === 'true') return;
    root.dataset.mtBtgReady = 'true';

    var targetSelector =
      root.getAttribute('data-target') || '.mt-custom-product-gallery';
    var showAfter = parseInt(root.getAttribute('data-show-after') || '200', 10);
    var lastY = window.scrollY || 0;
    var ticking = false;
    var visible = false;

    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      root.classList.toggle('is-visible', next);
      root.setAttribute('aria-hidden', next ? 'false' : 'true');
    }

    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      var scrollingUp = y < lastY;
      var pastThreshold = y > showAfter;

      // 下滑隐藏；上滑且已离开主图区域时弹出
      if (scrollingUp && pastThreshold) {
        setVisible(true);
      } else if (!scrollingUp && y > lastY) {
        setVisible(false);
      } else if (!pastThreshold) {
        setVisible(false);
      }

      lastY = y;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function scrollToGallery(event) {
      if (event) event.preventDefault();
      var target =
        document.querySelector(targetSelector) ||
        document.querySelector('.mt-custom-product-container') ||
        document.querySelector('#MainContent');

      if (!target) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      var header = document.querySelector('.mt-mega-header, sticky-header, .header-wrapper');
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.scrollY - offset - 8;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    root.addEventListener('click', scrollToGallery);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-mt-back-to-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var node = event.target && event.target.querySelector
      ? event.target.querySelector('[data-mt-back-to-gallery]')
      : null;
    if (node) init(node);
  });
})();
